module.exports = __webpack_public_path__ + "img/topicDomesticAppliances.1b92626e.png";